// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__rZvKK","inputDescription":"styles_inputDescription__1H2u5"};